import { useMemo } from 'react'
import ImagePlaceholder from '../../assets/imagePlaceholder.png'
import { Box } from '@material-ui/core'

type ImageIconProps = {
  imageSizeInPixels?: number
  iconSizeInPixels?: number
}

export function PlaceholderImageWithIcon({
  imageSizeInPixels = 84,
  iconSizeInPixels = imageSizeInPixels / 2,
}: ImageIconProps): JSX.Element {
  const formattedImageSize = useMemo(
    () => `${imageSizeInPixels}px`,
    [imageSizeInPixels],
  )
  const formattedIconSize = useMemo(
    () => `${iconSizeInPixels}px`,
    [iconSizeInPixels],
  )
  const boxWidth = useMemo(
    () => `calc(${formattedImageSize} + (${formattedIconSize}/2))`,
    [formattedImageSize, formattedIconSize],
  )
  const boxHeight = useMemo(
    () => `calc(${formattedImageSize} + (${formattedIconSize}*0.2))`,
    [formattedImageSize, formattedIconSize],
  )

  return (
    <Box sx={{ height: boxHeight, width: boxWidth, position: 'relative' }}>
      <img
        src={ImagePlaceholder}
        alt='placeholder'
        style={{ height: formattedImageSize, width: formattedImageSize }}
      />
    </Box>
  )
}
